import { isNil } from 'lodash-es';
import { toast } from 'react-toastify';
import { NRPOption, NRPType } from '@/api/apis/case';
import { retrieveUnifiedError } from '@/api/utils';
import { useUpdateNrpMutation } from '@/queries/case';
import { Uuid } from '@/api/types';

export const getBoolNrp = (nrpOption: NRPOption) => nrpOption === NRPOption.Yes;

export const useSetNrp = () => {
  const { mutateAsync: mutateNrp } = useUpdateNrpMutation();

  const handleNrpChange = async (nrpOption: NRPOption, nrpType: NRPType, caseId: Uuid, recordId?: string) => {
    try {
      const nrp = getBoolNrp(nrpOption);
      await mutateNrp({
        id: recordId,
        caseId,
        nrp,
        nrpType: nrp ? nrpType : NRPType.none,
      });
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  const createNrp = async (nrp: NRPOption | undefined, nrpType: NRPType, caseId: Uuid) => {
    if (!isNil(nrp)) {
      await handleNrpChange(nrp, nrpType, caseId);
    }
  };

  const updateNrp = async (
    nrp: NRPOption | undefined,
    nrpType: NRPType,
    nrpChanged: boolean,
    nrpTypeChanged: boolean,
    caseId: Uuid,
    recordId: string | undefined,
  ) => {
    if (!isNil(nrp) && (nrpChanged || nrpTypeChanged)) {
      await handleNrpChange(nrp, nrpType, caseId, recordId);
    }
  };

  return { createNrp, updateNrp };
};
